// PavoPay POS İade / Satış İptal penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.pavoPayRefund';

export const salesPavoPayRefundGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'PavoPay satışı nasıl iptal edilir?'),
  intro: t(`${G}.intro`, 'Bu pencerede PavoPay cihazında yapılmış bir satışı iptal eder, iadesini sisteme işlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Bugünün Satışları / Manuel İptal'),
    body: t(`${G}.regions.body`, 'Satış listesi veya satış no formu'),
    footer: t(`${G}.regions.footer`, 'Kapat / İptal Et'),
  },
  navItems: [
    t(`${G}.nav.today`, 'Bugünün Satışları'),
    t(`${G}.nav.manual`, 'Manuel İptal'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. İade mi, iptal mi?'),
      text: t(`${G}.s1.text`, 'Bu pencere satışı tamamen iptal eder: satışın ödemesi Pavo cihazında geri alınır. Kısmi iade (bazı ürünleri iade etme) buradan yapılmaz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Gün sonu alındıktan sonra bu listeden iptal yapılamaz.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Bugünün satışlarını bulun'),
      text: t(`${G}.s2.text`, '"Bugünün Satışları" sekmesi bu cihazdan bugün PavoPay ile yapılan satışları listeler: satış no, ödeme tipi, tutar, tarih ve fiş no. Arama kutusuna satış no, fiş no, kart numarası veya tutar yazarak arayın; sayfa başına 20 satış gösterilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Liste bu bilgisayarda tutulan kayıtlardan gelir; başka cihazda yapılan satış burada görünmez. Onun için "Manuel İptal" sekmesini kullanın.'),
        t(`${G}.s2.tip2`, 'Kulüp girişi satışlarında kart numarası da görünür.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Seçin ve iptal edin'),
      text: t(`${G}.s3.text`, 'İptal edilecek satışların kutucuklarını işaretleyin ("Tümünü Seç" arama sonucundaki tüm satışları seçer). "Seçili Satışları İptal Et" her satışı sırayla cihazda iptal eder. Başarılı satır yeşil, başarısız satır kırmızı görünür ve sonuç özeti açılır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Başarılı iptalde satış tutarı kadar POS iade kaydı sisteme işlenir ve satış listeden kalkar.'),
        t(`${G}.s3.tip2`, '"İptal başarılı (iade kaydı oluşturulamadı)" görürseniz cihazda iptal yapılmış ama sistem kaydı düşmemiştir; yöneticinize bildirin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Listede olmayan satışı manuel iptal edin'),
      text: t(`${G}.s4.text`, '"Manuel İptal" sekmesine geçin, "Satış Numarası"nı yazın ve "Satışı İptal Et"e basın. Satış numarasını PavoPay fiş çıktısında veya cihaz ekranında bulabilirsiniz.'),
      tips: [
        t(`${G}.s4.tip1`, '"İade Tutarı (Opsiyonel)" girilirse iptal gün sonu raporuna iade olarak yansır. Boş bırakılırsa yalnız cihazda iptal yapılır, sistemde iade kaydı oluşmaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Pencereyi kapatın'),
      text: t(`${G}.s5.text`, '"Kapat" pencereyi kapatır; iptal sürerken kapatılamaz. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
